import CamelItem from "../_/components/Camel"

const PageIndex = () => {
    return (<>
        <div className=" container mx-auto px-[33.998px] py-[4.533vw]">
            <div className=" container flex flex-wrap ">
                {Array.from({ length: 100 }, (_, i) => i + 1).map(v => {
                    return (<CamelItem id={v} key={v} />)
                })}
            </div>
        </div>
    </>)
}
export default PageIndex